/**
 * ESM shim for runtypes 6.x
 *
 * runtypes is CJS-only with circular internal requires that break Vite's
 * esbuild-based dev pre-bundling. This shim re-exports from a pre-bundled
 * ESM version (runtypes-bundle.mjs) generated via:
 *
 *   npx esbuild node_modules/runtypes/lib/index.js --bundle --format=esm --outfile=src/vendor/runtypes-bundle.mjs
 *
 * Regenerate after upgrading runtypes.
 */
import _rt from './runtypes-bundle.mjs';

export const Array = _rt.Array;
export const AsyncContract = _rt.AsyncContract;
export const BigInt = _rt.BigInt;
export const Boolean = _rt.Boolean;
export const Brand = _rt.Brand;
export const Constraint = _rt.Constraint;
export const Contract = _rt.Contract;
export const Dictionary = _rt.Dictionary;
export const Failcode = _rt.Failcode;
export const Function = _rt.Function;
export const Guard = _rt.Guard;
export const InstanceOf = _rt.InstanceOf;
export const InternalRecord = _rt.InternalRecord;
export const Intersect = _rt.Intersect;
export const Lazy = _rt.Lazy;
export const Literal = _rt.Literal;
export const Never = _rt.Never;
export const Null = _rt.Null;
export const Nullish = _rt.Nullish;
export const Number = _rt.Number;
export const Optional = _rt.Optional;
export const Partial = _rt.Partial;
export const Record = _rt.Record;
export const String = _rt.String;
export const Symbol = _rt.Symbol;
export const Template = _rt.Template;
export const Tuple = _rt.Tuple;
export const Undefined = _rt.Undefined;
export const Union = _rt.Union;
export const Unknown = _rt.Unknown;
export const ValidationError = _rt.ValidationError;
export const Void = _rt.Void;
export const check = _rt.check;
export const checked = _rt.checked;
export const match = _rt.match;
export const when = _rt.when;
export default _rt;
